import { merge } from 'lodash-es';
import * as yup from 'yup';

export function customFieldsUploadStatusDataFields() {
  return {
    id: yup.string().required(),
    fileName: yup.string().required(),
    status: yup.string().required(),
    entity: yup.string().required(),
    uploadedDate: yup.date().required(),
    user: yup.string().required().customMeta({
      formatter: 'userByEmail',
    }),
    fields: yup.array().of(yup.object()).required(),
  };
}

export function customFieldsUploadStatusDataSchema() {
  return yup.object().shape(customFieldsUploadStatusDataFields());
}

export type CustomFieldsUploadStatusData = yup.InferType<
  ReturnType<typeof customFieldsUploadStatusDataSchema>
>;

export function createCustomFieldsUploadStatusData(
  overrides: Partial<CustomFieldsUploadStatusData> = {}
): CustomFieldsUploadStatusData {
  return merge({}, customFieldsUploadStatusDataSchema().getDefault(), {
    fileName: '',
    status: '',
    entity: '',
    uploadedDate: undefined,
    ...overrides,
  });
}
